import React, { useEffect, useState, useRef } from 'react';
import gsap from 'gsap';
import './Banner.css';
import logo from "./logon.png";
import twitter from "./x-nailoong.png";
import dexscreener from "./dex-nailoong.png";

function Banner() {
  const [isMobile, setIsMobile] = useState(false);
  const contentRef = useRef(null);
  const logoRef = useRef(null);
  const iconsRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const play = () => video.play().catch(() => {});
    play();
    video.addEventListener("loadeddata", play);
    return () => video.removeEventListener("loadeddata", play);
  }, []);

  useEffect(() => {
    const content = contentRef.current;
    const logoEl = logoRef.current;
    const icons = iconsRef.current;
    if (!content || !logoEl || !icons) return;

    const iconEls = icons.querySelectorAll('a');
    gsap.set([logoEl, ...iconEls], { opacity: 0, y: 30, scale: 0.9 });
    const tl = gsap.timeline({ delay: 0.4 });
    tl.to(logoEl, { opacity: 1, y: 0, scale: 1, duration: 1, ease: 'back.out(1.4)' })
      .to(iconEls, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.5,
        stagger: 0.1,
        ease: 'power2.out',
      }, '-=0.4');
  }, []);

  const videoSrc = isMobile
    ? "https://res.cloudinary.com/dep7dpjup/video/upload/v1772591488/Free_2D_Cloud_Animation_l_Cartoon_Background_For_Free_l_No_Copyright_online-video-cutter.com_y82wtv.mp4"
    : "https://res.cloudinary.com/dep7dpjup/video/upload/v1772591488/Free_2D_Cloud_Animation_l_Cartoon_Background_For_Free_l_No_Copyright_online-video-cutter.com_y82wtv.mp4";

  return (
    <header className={`banner ${isMobile ? "mobile-fix" : ""}`}>
      <video
        ref={videoRef}
        key={videoSrc}
        className="banner-video"
        src={videoSrc}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      />
      <div className="banner-overlay"></div>

      <div ref={contentRef} className="banner-content">
        <img ref={logoRef} src={logo} alt="Logo" className="banner-logo" />
        <div ref={iconsRef} className="banner-icons">
          <a href="https://x.com/i/communities/2029948076094324765" target="_blank" rel="noopener noreferrer">
            <img src={twitter} alt="X" />
          </a>
          <a href="https://dexscreener.com/solana/djeseq7g4khfnehqcamfkmtpuvufvx4q89eprwlnl2ss" target="_blank" rel="noopener noreferrer">
            <img src={dexscreener} alt="Dexscreener" />
          </a>
        </div>
      </div>
    </header>
  );
}

export default Banner;
